export async function unwrapNetworkResponse<T>(response: Response) {
  const data: unknown = await response.json();
  if (!response.ok) {
    throw data;
  }

  return data as T;
}

export interface SignalProp {
  signal?: AbortSignal;
}

export type FetchMethod = 'GET' | 'PUT' | 'POST' | 'PATCH' | 'DELETE';

export interface BaseNetworkProp extends SignalProp {
  baseUrl: string;
  body?: unknown;
}

export interface BaseNetworkRequestProp extends BaseNetworkProp {
  method: FetchMethod;
  headers?: { [key: string]: string };
  relativeUrl: `/${string}`;
}

export function getFetchSignal(signal?: AbortSignal | undefined) {
  return AbortSignal.any([
    // Add timeout to fetch
    AbortSignal.timeout(10000),
    // Manual cancellation
    ...(signal ? [signal] : []),
  ]);
}
